import theme from '../theme'
import { makeStyles } from '@material-ui/core'

const styleOverride = makeStyles({
  colorPrimary: {
    color: theme.palette.primary.main,
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  colorSecondary: {
    color: theme.palette.secondary.main,
    '&.Mui-checked': {
      color: theme.palette.secondary.main,
    },
  },
})

export default styleOverride
